export default __webpack_public_path__ + "static/media/crm-line-chart.cee93078.png";